/**
 * Voyado Elevate product-page tracking for PDP visits.
 * Depends on elevate-core.js
 */

class ElevateProductPage extends HTMLElement {
  #loaded = false;

  connectedCallback() {
    this.trackVisit();
  }

  async #waitForCore() {
    if (window.ElevateCore?.readConfigFromElement) {
      return window.ElevateCore;
    }

    return new Promise((resolve) => {
      const deadline = Date.now() + 4000;
      const tick = () => {
        if (window.ElevateCore?.readConfigFromElement) {
          resolve(window.ElevateCore);
          return;
        }

        if (Date.now() > deadline) {
          resolve(null);
          return;
        }

        setTimeout(tick, 25);
      };

      tick();
    });
  }

  async trackVisit() {
    if (this.#loaded) {
      return;
    }

    this.#loaded = true;

    const ElevateCore = await this.#waitForCore();

    if (!ElevateCore) {
      return;
    }

    const config = {
      ...ElevateCore.readConfigFromElement(this),
      productKey: this.dataset.productKey
    };

    if (!config?.clusterId || !config?.market || !config?.locale || !config.productKey) {
      return;
    }

    try {
      const data = await ElevateCore.fetchProductPage(config, {
        productGroup: { include: true }
      });

      ElevateCore.storeProductPageTickets(data, this.dataset.productId, this.dataset.currentVariantId);
    } catch (_error) {
      // Non-blocking analytics.
    }
  }
}

if (!window.customElements.get('elevate-product-page')) {
  window.customElements.define('elevate-product-page', ElevateProductPage);
}
